import { render, staticRenderFns } from "./SafetyInfo.vue?vue&type=template&id=771ecd72&scoped=true"
import script from "./SafetyInfo.vue?vue&type=script&lang=js"
export * from "./SafetyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771ecd72",
  null
  
)

export default component.exports